module.exports = __webpack_public_path__ + "static/media/happiness-survey-preview.c8e03ab9.png";